var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4596_14704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9319 34.7274L42.4152 29.0669L55.6616 25.5175L53.3506 16.8929L17.2803 26.5579L19.5913 35.1825L32.8392 31.6328L34.3547 37.2887C23.7175 40.6568 16.1803 44.9097 16.8491 47.4058C17.518 49.902 26.1757 49.8154 37.0688 47.4178L41.9271 65.5491L51.5062 62.9824L46.6475 44.8496C57.2649 41.4851 64.7861 37.2382 64.1179 34.7443C63.4497 32.2504 54.8126 32.3331 43.9354 34.728M46.236 43.3139L46.2348 43.3093C45.969 43.3984 44.6023 43.8519 41.5105 44.6804C39.0386 45.3427 37.2812 45.7402 36.66 45.8732L36.662 45.8808C27.0396 48.0179 19.5056 48.3017 18.9867 46.3649C18.4677 44.4281 25.1356 40.909 34.5364 37.948L36.2299 44.2682C36.8641 44.1432 38.6735 43.7684 41.1329 43.1094C44.0869 42.3179 45.5398 41.7998 45.8059 41.7024L44.1124 35.3821C53.7165 33.2516 61.2345 32.9737 61.7516 34.9036C62.2688 36.8336 55.6161 40.3535 46.2365 43.3096",
    fill: "url(#paint0_linear_4596_14704)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9319 34.7274L42.4152 29.0669L55.6616 25.5175L53.3506 16.8929L17.2803 26.5579L19.5913 35.1825L32.8392 31.6328L34.3547 37.2887C23.7175 40.6568 16.1803 44.9097 16.8491 47.4058C17.518 49.902 26.1757 49.8154 37.0688 47.4178L41.9271 65.5491L51.5062 62.9824L46.6475 44.8496C57.2649 41.4851 64.7861 37.2382 64.1179 34.7443C63.4497 32.2504 54.8126 32.3331 43.9354 34.728M46.236 43.3139L46.2348 43.3093C45.969 43.3984 44.6023 43.8519 41.5105 44.6804C39.0386 45.3427 37.2812 45.7402 36.66 45.8732L36.662 45.8808C27.0396 48.0179 19.5056 48.3017 18.9867 46.3649C18.4677 44.4281 25.1356 40.909 34.5364 37.948L36.2299 44.2682C36.8641 44.1432 38.6735 43.7684 41.1329 43.1094C44.0869 42.3179 45.5398 41.7998 45.8059 41.7024L44.1124 35.3821C53.7165 33.2516 61.2345 32.9737 61.7516 34.9036C62.2688 36.8336 55.6161 40.3535 46.2365 43.3096",
    fill: "url(#paint1_linear_4596_14704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4596_14704",
    x: 0.808594,
    y: 0.892822,
    width: 79.3496,
    height: 80.6562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4596_14704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14704",
    x1: 35.2999,
    y1: 21.7296,
    x2: 46.6987,
    y2: 64.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CFFC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14704",
    x1: 35.2999,
    y1: 21.7296,
    x2: 46.6987,
    y2: 64.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CFFC7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsdt);
export default __webpack_public_path__ + "static/media/ic_usdt.07dbe955449ecff0e62b0d2321324ce3.svg";
export { ForwardRef as ReactComponent };